var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(`width: 100%; height: ${
    _vm.height || 500
  }px; overflow: hidden; ${_vm.extraMapStyle}`),attrs:{"id":_vm.mapId}},[_c('div',{ref:"googleMap",staticClass:"google-map",staticStyle:{"width":"100%","height":"100%"}}),(Boolean(this.google) && Boolean(this.map))?[_vm._t("default",null,{"google":_vm.google,"map":_vm.map})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }